<template>
    <b-container>
        <div v-for="usr in bonuses" :key="usr.id">
            <b-card
                :header="usr.name"
                class="mb-5"
                v-if="user.profile.slug !== 'supervisor' || usr.id === user.id"
                :id="`user-${usr.id}`"
            >
                <b-card-text>
                    <div class="table-responsive">
                        <table class="table w-100 table-bordered table-sm">
                            <tr>
                                <th>
                                    Indicador
                                </th>
                                <th>
                                    Cumplimiento
                                </th>
                                <th>Bono</th>
                            </tr>
                            <tr
                                v-for="bonus in usr.supervisor_goal_bonuses"
                                :key="bonus.id"
                            >
                                <td>
                                    {{
                                        bonus.fact_supervisor_indicator
                                            .indicator_name
                                    }}
                                </td>
                                <td class="text-center">{{ bonus.value }}%</td>
                                <td class="text-center">
                                    ${{ bonus.bonus | currency }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <h4 class="text-success">Incentivo</h4>
                                </td>
                                <td class="text-center">
                                    <h4 class="text-success">
                                        ${{ getTotalBonus(usr) | currency }}
                                    </h4>
                                </td>
                            </tr>
                        </table>
                    </div>
                </b-card-text>
            </b-card>
        </div>
    </b-container>
</template>
<script>
import { BTable } from 'bootstrap-vue'
export default {
    components: {
        BTable,
    },
    props: {
        bonuses: {
            type: Array,
            default: [],
        },
    },
    data: () => ({}),
    computed: {},
    methods: {
        getTotalBonus(usr) {
            let bonus = 0

            usr.supervisor_goal_bonuses.map((item) => (bonus += item.bonus))

            return bonus
        },
    },
}
</script>
